const formatPermissions = user => user.accessList.map(a => a.access);

export default formatPermissions;
